// IntroPage.js
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import config from '../Configs/Config';
import WhatsAppButton from '../Components/Whatsapp'
import PhoneNumber from '../Components/PhoneNumber';
import { useTranslation } from "react-i18next";
import { Trans } from "react-i18next";

const Home = () => {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const section = document.getElementById(id);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  return (
    <div className="homeContainer">
      
      <section id="home" className="section headerMargin tricolor-background">
        <h4 className="pb50"><strong>{config.siteName}</strong> – {t('home.subtitle_1')}</h4>
        
        <p><strong>"{t('home.subtitle_2')}"</strong></p>
        <p className='text-left'><Trans i18nKey='home.p1.l1' /></p>
        
        <ul className='text-left'>
          <li><strong>{t('home.p1.ul1.li1')}</strong></li>
          <li><strong>{t('home.p1.ul1.li2')}</strong></li>
          <li><strong>{t('home.p1.ul1.li3')}</strong></li>
        </ul>
        
        <p className='text-left'><Trans i18nKey='home.p2.l1' /></p>
        <ul className='text-left'>
          <Trans i18nKey='home.p2.ul1' />
        </ul>
      </section>

      <section id="about" className="section tricolor-background">
        <h2 className="pb50"><Trans i18nKey='about.subtitle_1' /></h2>
        <p className='text-left'><Trans i18nKey='about.p1.l1' values={{ siteName: config.siteName, partyRegNos: config.partyRegNos }} /> </p>
        <p className='text-left'><Trans i18nKey='about.p2.l1' /></p>
        <p className='text-left'><Trans i18nKey='about.p3.l1' /></p>
        <p className='text-left'><Trans i18nKey='about.p4.l1' /></p>
        <p><a className='fs18' href="https://eci.gov.in/political-parties/political-parties-list/" target="_blank" rel="noopener noreferrer"><Trans i18nKey='about.p5.verify_link' /></a></p>
      </section>

      <section id="mission" className="section tricolor-background">
        
        <h4 className="pb50"><Trans i18nKey='mission.subtitle_1' /></h4>
        <p><Trans i18nKey='mission.p1.l1' /></p>
        
        <ul className='text-left'>
          <Trans i18nKey='mission.p1.ul1' />
        </ul>
        <p><Trans i18nKey='mission.p2.l1' /></p>
        <p className='text-left'><Trans i18nKey='mission.p2.l2' /></p>
        <ul className='text-left'>
          <Trans i18nKey='mission.p2.ul1' />
        </ul>
        <p className='text-left mb2'><Trans i18nKey='mission.p3.l1' /></p>
        <p className='text-left'><Trans i18nKey='mission.p3.l2' values={{siteLongTitle: config.siteLongTitle}} /> </p>
        <p><a className='fs18' href="/join-movement"><Trans i18nKey='mission.p3.link_join' /></a></p>
      </section>

      <section id="contact" className="section tricolor-background">
        <h2 className="pb50"><Trans i18nKey='contact.subtitle_1' /></h2>
        
        <div className="contact-container">

          <p><Trans i18nKey='contact.p1.l1' /></p>
          <p className='text-left mb2'><Trans i18nKey='contact.p1.l2' values={{siteLongTitle: config.siteLongTitle}} /></p>
          <p className='text-left'><Trans i18nKey='contact.p1.l3' /></p>
          
          <p><Trans i18nKey='contact.p2.l1' /></p>
          <p className='text-left mb2'><Trans i18nKey='contact.p2.l2' /></p>
          <p className='text-left'><Trans i18nKey='contact.p2.l3' /></p>

          <p className='text-left mb2'><Trans i18nKey='contact.p3.l1' /> <PhoneNumber /> </p>
          <p className='text-left mb2'><Trans i18nKey='contact.p3.l2' /> <WhatsAppButton /></p>
          <p className='text-left mb2'><Trans i18nKey='contact.p3.l3' /> md2458@gmail.com, abipp2023@gmail.com</p>
          <p className='text-left'><Trans i18nKey='contact.p3.l4' /></p>
          <p className='text-left'><Trans i18nKey='contact.p3.l5' values={{partyRegNos: config.partyRegNos}} /></p>

          {/* <div className="social-links">
            <a href="https://facebook.com/yourparty" target="_blank">Facebook</a>
            <a href="https://twitter.com/yourparty" target="_blank">Twitter</a>
            <a href="https://instagram.com/yourparty" target="_blank">Instagram</a>
          </div> */}
        
        </div>
      </section>
    </div>
  );

};

export default Home;